import FieldConfig from "../../../proto/field-config"
import FieldText from "../../../generic/text/text"
import FieldTaskDescription_TableCell from "./render/table/table-cell"

export default class FieldTaskDescription extends FieldText {

    constructor(config:FieldConfig) {
        super(config)

        this.icon = 'i5-sticky-note'

        this.renderComponents.tableCell = FieldTaskDescription_TableCell
    }
}
